import api from '../api';

/**
 * Remove reservations from a specific table.
 *
 * @param {string} tableCode - The code of the table from which reservations are to be removed.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const removeReservationsFromTable = async (tableCode,reservationTime) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/store/removeReservation`;

  try {
    const response = await api.post(endpoint, { tableCode,reservationTime });
    return response.data;
  } catch (error) {
    console.error('Error removing reservations:', error);
    throw error;
  }
}

export default removeReservationsFromTable;
